import { IconFooterLoadingPlaceholder, useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { IconFooterUi } from './ui';
import { useIconFooter } from './useIconFooter';

const IconFooterWithHandlers = withLoadingAndNoConnectionHandler(IconFooterUi);

export const IconFooter: React.FC = () => {
    const { cmsContent: iconFooter, isLoading, loadingError } = useIconFooter();
    const { isAuthenticated } = useOidcAuthentication();

    return (
        <IconFooterWithHandlers
            isLoading={isLoading}
            iconFooter={iconFooter}
            hasError={!!loadingError}
            isLoggedIn={isAuthenticated}
            loadingPlaceholder={<IconFooterLoadingPlaceholder />}
        />
    );
};
